var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKz = function SvgKz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none",
    viewBox: "0 0 21 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6148e33d-2a9d-48a4-abb1-7720560e2de1a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "1d8b64f5-3b5e-4096-973c-e269be0736f2b",
    width: 21,
    height: 15,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#1d8b64f5-3b5e-4096-973c-e269be0736f2b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00AFCC",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DAC21D",
    fillRule: "evenodd",
    d: "M2 2.495C2 2.222 2.232 2 2.5 2c.276 0 .5.216.5.495v2.01A.503.503 0 0 1 2.5 5a.494.494 0 0 1-.5-.495zm1 2C3 4.222 3.232 4 3.5 4c.276 0 .5.216.5.495v2.01A.503.503 0 0 1 3.5 7a.494.494 0 0 1-.5-.495zm0 4C3 8.222 3.232 8 3.5 8c.276 0 .5.216.5.495v2.01a.503.503 0 0 1-.5.495.494.494 0 0 1-.5-.495zm-1 2c0-.273.232-.495.5-.495.276 0 .5.216.5.495v2.01a.503.503 0 0 1-.5.495.494.494 0 0 1-.5-.495zM2 6.5c0-.276.232-.5.5-.5.276 0 .5.232.5.5 0 .276-.232.5-.5.5a.505.505 0 0 1-.5-.5m1-4c0-.276.232-.5.5-.5.276 0 .5.232.5.5 0 .276-.232.5-.5.5a.505.505 0 0 1-.5-.5m-1 5c0-.276.232-.5.5-.5.276 0 .5.232.5.5 0 .276-.232.5-.5.5a.505.505 0 0 1-.5-.5m1 5c0-.276.232-.5.5-.5.276 0 .5.232.5.5 0 .276-.232.5-.5.5a.505.505 0 0 1-.5-.5m-1-4c0-.276.232-.5.5-.5.276 0 .5.232.5.5 0 .276-.232.5-.5.5a.505.505 0 0 1-.5-.5",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC600",
    d: "M11.5 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC600",
    fillRule: "evenodd",
    d: "m8 7 1 2 2.5 1L14 9l1-2v3l-3.5 1L8 10z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19 .5H2A1.5 1.5 0 0 0 .5 2v11A1.5 1.5 0 0 0 2 14.5h17a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 19 .5Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "6148e33d-2a9d-48a4-abb1-7720560e2de1a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v15H0z"
  })))));
};
export default SvgKz;